import React from 'react';

type RushLogoProps = {
  /** Height of the logo image in px (or any CSS length string) */
  height?: string | number;
  /** When true, wrap in a white rounded card so it reads on dark backgrounds */
  onDark?: boolean;
  /** Tailwind/CSS classes applied to the outermost element */
  className?: string;
};

const RushLogo = ({ height, onDark = true, className }: RushLogoProps) => {
  const h = height != null ? (typeof height === 'number' ? `${height}px` : height) : '100%';

  const img = (
    <img
      src="/RUSH-logo.png"
      alt="RUSH Automated Systems"
      style={{ height: h, width: 'auto', display: 'block' }}
      draggable={false}
    />
  );

  if (!onDark) return img;

  return (
    <div
      className={className}
      style={{
        background: 'rgba(255,255,255,0.96)',
        borderRadius: 12,
        padding: '8px 20px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {img}
    </div>
  );
};

export default RushLogo;
